module.exports = __webpack_public_path__ + "static/media/logo_via_plus.5425ac48.png";